<template>
    <div
        @click="showSideBarHandler"
        class="font-[Inter] border rounded-md border-won-green px-4 py-2 mb-2.5 shadow-card cursor-pointer left-sidebar"
    >
        <div class="flex justify-between text-[8px] items-center">
            <div
                class="text-won-blue font-bold leading-3 bg-won-yellow-light bg-opacity-50 rounded-full px-[5px] py inline-block"
            >
                Job Search Plan
            </div>
            <div class="flex items-center select-none">
                <span class="font-semibold text-won-green"> Learn more </span>
                <ChevronRightIcon class="size-3 text-won-green" />
            </div>
        </div>

        <div class="mt-1">
            <ProgressBar
                :viewing-step-index="currentStepIndexCopy"
                :current-step-index="currentStepIndexCopy"
                :label="stepsArray[currentStepIndexCopy]?.title || 'test'"
                :steps="stepsArray"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useJobSearchPlanStore } from "../../store/job-search-plan.store";
import { stepsArray } from "../../utils/job-search-plans";

import ProgressBar from "./progress-bar.vue";

import { ChevronRightIcon } from "@heroicons/vue/20/solid";

const jobSearchPlanStore = useJobSearchPlanStore();

const { isSidebarVisible, currentStepIndex } = storeToRefs(jobSearchPlanStore);

const currentStepIndexCopy = computed(() => currentStepIndex.value);

const showSideBarHandler = () => {
    isSidebarVisible.value = true;
};
</script>
